function writeCookie(name, value, days) {
  var date, expires;
  if(days) {
      date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toGMTString();
  } else {
      expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
  var i, c, ca, nameEQ = name + "=";
  ca = document.cookie.split(';');
  for(i=0; i < ca.length; i++) {
      c = ca[i];
      while(c.charAt(0)==' ') {
          c = c.substring(1,c.length);
      }
      if(c.indexOf(nameEQ) == 0) {
          return c.substring(nameEQ.length,c.length);
      }
  }
  return '';
}

export default class CookieStorage {
  static get(name) {
    return readCookie(name);
  }

  static save(name, value, days) {
    writeCookie(name, value, days);
  }

  static remove(name) {
    //localStorage.removeItem(name);
    writeCookie(name, '');
  }
}



// WEBPACK FOOTER //
// ./src/helpers/StorageHandler/CookieStorage.js